import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAwareness = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 240 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M120 0H2.11238C0.964885 0 0.0519516 0.965099 0.1245 2.11029C1.63876 26.0133 6.40232 44.7397 14.261 62.808C14.5765 63.5336 15.2944 64 16.0856 64H223.914C224.706 64 225.423 63.5336 225.739 62.808C233.598 44.7397 238.361 26.0133 239.876 2.11029C239.948 0.965099 239.035 0 237.888 0H120Z",
		fill: "#C7DFFC"
	})
});
export default SvgAwareness;
